import Base from '@studiometa/js-toolkit';
import Choices from 'choices.js';
import ProductGallery from './ProductGallery.js';
import { isDev } from '../config.js';

/**
 *  component
 */
export default class Product extends Base {
  /**
   * Component Configuration
   */
  get config() {
    return {
      name: 'Product',
      log: isDev(),
      components: {
        ProductGallery,
      },
    };
  }

  /**
   * Mounted hook
   */
  mounted() {
    this.setContainerHeight();

    this.$refs.select.forEach((select) => {
      // eslint-disable-next-line no-new
      new Choices(select, {
        searchEnabled: false,
        itemSelectText: '✓',
      });
    });
  }

  /**
   * Resized service hook
   * @see https://js-toolkit.meta.fr/services/resize.html
   * @param {number} width The width of the viewport.
   * @param {number} height The height of the viewport.
   * @param {number} ratio The width / height ratio of the viewport.
   * @param {string} orientation square, portrait or landscape
   * @param {string} breakpoint The current active breakpoint extracted from the content value of the ::before pseudo-element on the first [data-breakpoint] element found in the DOM.
   */
  resized() {
    this.setContainerHeight();
  }

  /**
   * Get gallery container height from child to avoid weird layout behavior from position absolute
   */
  setContainerHeight() {
    this.$refs.container.style.height = `${
      this.$refs.gallery[0].$el.getBoundingClientRect().height
    }px`;
  }

  /**
   * Select change
   */
  onSelectChange(event) {
    const { value } = event.target;

    if (value === '') {
      return;
    }

    this.$refs.gallery.forEach((gallery) => {
      gallery.$el.classList.remove('is-visible');

      if (gallery.$el.dataset.name === value) {
        gallery.$el.classList.add('is-visible');
      }
    });
  }
}
